import { SegmentedControl } from '@hue/design-system';
import type { PurchasingView } from '../../app/list-views.js';
import type { ViewSetter } from '../../app/view-state.js';
import { OfferingsPanel } from './offerings-panel.js';
import { SuppliersPanel } from './suppliers-panel.js';
import type { PurchasingCapabilities } from './shared.js';
import { PurchasingMovementsPanel } from './movements-panel.js';
import { PageHeader } from '../../app/page-title.js';

const tabs = [
  ['offerings', 'Ofertas'],
  ['suppliers', 'Fornecedores'],
  ['orders', 'Pedidos'],
  ['receipts', 'Recebimentos'],
] as const;

export function CompanyPurchasing({
  capabilities,
  consolidated = false,
  timeZone,
  view,
  onView,
}: {
  capabilities: PurchasingCapabilities;
  consolidated?: boolean;
  timeZone: string;
  view: PurchasingView;
  onView: ViewSetter<PurchasingView>;
}) {
  return (
    <section aria-labelledby="company-purchasing-title">
      <PageHeader
        trail="Operação / Compras"
        id="company-purchasing-title"
        title="Compras"
        description="De quem a empresa compra, o que cada fornecedor vende e em que condições."
      />
      {consolidated && (view.tab === 'orders' || view.tab === 'receipts') ? (
        <p
          role="status"
          className="mb-5 rounded-2xl border border-surface-border bg-surface-card p-4 text-sm text-content-secondary"
        >
          Visão consolidada: pedidos e recebimentos de todas as suas unidades, só para consulta.
          Para registrar ou cancelar, escolha uma unidade no seletor acima.
        </p>
      ) : null}
      <SegmentedControl
        tabs
        label="Áreas de compras"
        className="mb-6"
        options={tabs.map(([value, label]) => ({ value, label }))}
        value={view.tab}
        onChange={(tab) => onView({ tab })}
      />
      {view.tab === 'offerings' ? (
        <OfferingsPanel capabilities={capabilities} view={view} onView={onView} />
      ) : view.tab === 'suppliers' ? (
        <SuppliersPanel
          capabilities={capabilities}
          timeZone={timeZone}
          view={view}
          onView={onView}
        />
      ) : (
        <PurchasingMovementsPanel
          kind={view.tab}
          capabilities={capabilities}
          timeZone={timeZone}
          showUnits={consolidated}
          view={view}
          onView={onView}
        />
      )}
    </section>
  );
}
